import React from "react";
import App from "./App";

const AppContainer = () => {
    return <App />;
};

export default AppContainer;
